import API from '../api'
import postUrl from './paths'

export const createAuction = (auction, user) =>
	new Promise((resolve, reject) => {
		auction.supplier = user.getUserDetails()
		auction.supplier.is_primary = true

		auction.created_by = user?.user_id
		auction.created_at = new Date().getTime()

		API.post(postUrl.createAuction, auction)
			.then((response) => {
				resolve(response.data)
			})
			.catch((err) => reject(err))
	})

export const createOrderFromAuction = (auctionId, orderDate = new Date().getTime(), userId) =>
	new Promise((resolve, reject) => {
		API.post(postUrl.createOrderFromAuction, {}, { auctionId, orderDate, userId })
			.then((response) => {
				resolve(response.data)
			})
			.catch((err) => reject(err))
	})
